"use client";

import clsx from "clsx";
import { Text } from "@repo/ui/text";
import {
  TYPOGRAPHY_BODY3_BOLD,
  TYPOGRAPHY_LABEL3_BLACK,
  TYPOGRAPHY_SMALLPRINT,
} from "@/theme/topshop/typography/typography-constants";
import type { BannerContent } from "./global-banner.types";
import styles from "./global-banner.module.css";

type GlobalBannerProps = {
  content: BannerContent;
};

export const GlobalBanner = ({ content }: GlobalBannerProps) => {
  const renderSubtitle = () => {
    if (!content.subtitle) return null;

    // Cyber Monday periods: highlight "NEW CUSTOMERS" in green
    if (content.colorScheme === "cyberMonday") {
      const parts = content.subtitle.split("NEW CUSTOMERS");
      if (parts.length === 2) {
        return (
          <Text className={TYPOGRAPHY_BODY3_BOLD} suppressHydrationWarning>
            <span className={styles.subtitleHighlight}>NEW CUSTOMERS</span>
            {parts[1]}
          </Text>
        );
      }
    }

    return (
      <Text
        className={clsx(
          TYPOGRAPHY_BODY3_BOLD,
          content.colorScheme === "blackFriday" && styles.subtitleHighlight,
        )}
        suppressHydrationWarning
      >
        {content.subtitle}
      </Text>
    );
  };

  return (
    <div
      className={clsx(styles.banner, styles[content.colorScheme])}
      suppressHydrationWarning
    >
      <div className={styles.content} suppressHydrationWarning>
        <Text
          className={clsx(
            TYPOGRAPHY_BODY3_BOLD,
            content.colorScheme === "lastChanceBlackFriday" &&
              styles.titleHighlight,
            content.colorScheme === "cyberMonday" && styles.titleHighlight,
          )}
          suppressHydrationWarning
        >
          {content.title}
        </Text>
        {renderSubtitle()}
        <Text
          className={clsx(
            TYPOGRAPHY_SMALLPRINT,
            styles.text,
            content.colorScheme === "cyberMonday" && styles.textHighlight,
          )}
          suppressHydrationWarning
        >
          {content.text}{" "}
          <strong
            className={clsx(styles.codeHighlight, TYPOGRAPHY_LABEL3_BLACK)}
            suppressHydrationWarning
          >
            {content.code}
          </strong>{" "}
          AT CHECKOUT
        </Text>
      </div>
    </div>
  );
};
